// extracted by mini-css-extract-plugin
export default {"cls1":"j2HBk3ps_8QsN8cE4CQJ","cls2":"wwTbQn3UGIjIDOv1Y7xQ j2HBk3ps_8QsN8cE4CQJ","blink":"ckSkZ_EwN_k0_pRJKR8b"};